export default "__VITE_ASSET__CItMlqL0__"